import { render, staticRenderFns } from "./MarginTrade.vue?vue&type=template&id=155b7d98&scoped=true"
import script from "./MarginTrade.vue?vue&type=script&lang=js"
export * from "./MarginTrade.vue?vue&type=script&lang=js"
import style0 from "./MarginTrade.vue?vue&type=style&index=0&id=155b7d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b7d98",
  null
  
)

export default component.exports